import TextM from './TextM';

export default TextM;
